// extracted by mini-css-extract-plugin
export default {"text-color-light":"#707070","textColorLight":"#707070","color-mischka":"#e0e1e7","colorMischka":"#e0e1e7","button":"_7FjBQ hRgdS","content":"spjrb","closed":"yWtwI","open":"_8L79W"};